import { Divider , Title , Container , SimpleGrid} from "@mantine/core"
import { ArticlesCardsGrid } from '../Components/Cards';
import { SlideShow } from '../Components/Carousel';
import { UserInfoAction } from '../Components/UserCard';
import { GetInTouch } from "../Components/ContactUs";
import { HeaderMiddle } from '../Components/Header';
import { FooterSimple } from '../Components/Footer';


const listData = {
  "links": [
    {
      "link": "homeTop",
      "label": "Home"
    },
    {
      "link": "ourProducts",
      "label": "Products"
    },
    {
      "link": "ourTeam",
      "label": "Team"
    },
    {
      "link": "contactUs",
      "label": "Contact"
    }
  ],
  "footerLink": [
    {
      "link": "#",
      "label": "Copyright @ 2023"
    },
    {
      "link": "/privacy_policy",
      "label": "Privacy Policy"
    },
    {
      "link": "/terms_and_conditions",
      "label": "Terms and Condition"
    }
  ]
}

function HomePage() {
  return (
    <div className="App" id="homeTop">
      <HeaderMiddle links={listData.links}/>
        <SlideShow/>
        <Title order={1} color="dimmed" style={{marginTop : 18}} id="ourProducts">Our Products</Title>
        <Divider size="lg" style={{marginTop : 18}} />
        <ArticlesCardsGrid/>

        <Title order={1} color="dimmed" style={{marginTop : 18}} id="ourTeam">Our Team</Title>
        <Divider size="lg" style={{marginTop : 18 , marginBottom : 18}} />
        <Container size="xl">
        <SimpleGrid cols={2} breakpoints={[{ maxWidth: 'sm', cols: 1 }]}>
            <UserInfoAction {...{
              "avatar": "https://firebasestorage.googleapis.com/v0/b/freak-bros.appspot.com/o/myself.jpg?alt=media&token=e07f0d80-522e-467c-afb1-5873403a3454",
              "name": "Sushant Jaiswal",
              "email": "sushantkjaiswal5@gmail.com",
              "job": "Programmer",
              "link": "/sushant"
            }} />
            <UserInfoAction {...{
              "avatar": "https://firebasestorage.googleapis.com/v0/b/freak-bros.appspot.com/o/chippi.jpg?alt=media&token=c6ada32a-3857-4b7c-9b9c-9d23916af7b4",
              "name": "Ayush Raj",
              "email": "ayushrajgupta09@gmail.com",
              "job": "3D Artist",
              "link": "/ayushraj"
            }} />
          </SimpleGrid>
        </Container>
        
        <Title order={1} color="dimmed" style={{marginTop : 18}} id="contactUs">Contact Us</Title>
        <Divider size="lg" style={{marginTop : 18 , marginBottom : 18}} />
        <Container size="sm">
          <GetInTouch/>
        </Container>
        <FooterSimple links={listData.footerLink}/>
    </div>
  );
}

export default HomePage;
